import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Schedule from "../views/Schedule.vue";
import Headless from "../views/Headless.vue";
import Swiper from "../views/Swiper.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Schedule',
    props: true,
    component: Schedule,
  },
  {
    path: '/gl',
    name: 'ScheduleGlobal',
    props: true,
    component: Schedule,
  },
  {
    path: '/iframe/:category?',
    name: 'Iframe',
    props: true,
    component: Headless,
  },
  {
    path: '/gliframe/:category?',
    name: 'IframeGlobal',
    props: true,
    component: Headless,
  },
  {
    path: '/swiper/:category?',
    name: 'Swiper',
    props: true,
    component: Swiper,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
